import React, { useEffect, useState, useCallback } from "react";
import { FiAlertTriangle, FiZap } from "react-icons/fi";
import WebService from "../../Services/WebService";
import ProfileAiErrorsModal from "../QuickActions/ProfileAiErrorsModal";
import "./header_quick_action.scss";

const HeaderQuickAction: React.FC = () => {
  const [errorCount, setErrorCount] = useState<number>(0);
  const [showModal, setShowModal] = useState<boolean>(false);

  const fetchErrorCount = useCallback(() => {
    const token = localStorage.getItem("access_token");
    if (!token) return;

    WebService.getAPI({
      action: "quick-actions/profile-ai-errors?offset=0&per_page=1",
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          const count = Number(res.count ?? res.data?.count ?? (res.list?.length || 0)) || 0;
          setErrorCount(count);
        }
      })
      .catch(() => {
        // Silently fail if endpoint is unreachable
      });
  }, []);

  useEffect(() => {
    fetchErrorCount();

    const interval = setInterval(() => {
      fetchErrorCount();
    }, 60000);

    return () => clearInterval(interval);
  }, [fetchErrorCount]);

  return (
    <>
      <div className="header-quick-action">
        <button
          type="button"
          className={`hqa-btn ${errorCount > 0 ? "has-errors" : "is-clean"}`}
          onClick={() => setShowModal(true)}
          title={
            errorCount > 0
              ? `${errorCount} Profile AI Analysis issue(s) require attention.`
              : "Quick Actions: All profile AI analyses are healthy."
          }
        >
          <span className="hqa-icon">
            {errorCount > 0 ? <FiAlertTriangle size={15} /> : <FiZap size={15} />}
          </span>
          <span className="hqa-text">Quick Actions</span>
          {errorCount > 0 ? (
            <span className="hqa-badge">{errorCount}</span>
          ) : (
            <span className="hqa-badge-clean">0</span>
          )}
        </button>
      </div>

      <ProfileAiErrorsModal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          fetchErrorCount();
        }}
        onRefreshCount={fetchErrorCount}
      />
    </>
  );
};

export default HeaderQuickAction;
